"use client";

import { AnimatePresence, motion, useReducedMotion } from "motion/react";
import CourseCard from "@/components/CourseCard/CourseCard";

// Fondus et glissements courts, sans rebond.
const EASE = { duration: 0.3, ease: [0.22, 1, 0.36, 1] };

/**
 * La grille des formations. Au changement d'onglet ou de catégorie, les cartes
 * qui restent glissent à leur nouvelle place ; celles qui partent et celles qui
 * arrivent passent par un fondu court. La page garde une seule grille pour tous
 * les onglets : c'est ce qui permet aux cartes de survivre au changement.
 *
 * @param {object} props
 * @param {object[]} props.courses Les formations à afficher, dans l'ordre.
 */
export default function CoursesGrid({ courses }) {
    const reduceMotion = useReducedMotion();

    return (
        <div className="grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-5 mt-5">
            <AnimatePresence mode="popLayout" initial={false}>
                {courses.map((course) => (
                    <motion.div
                        key={course.slug}
                        layout={!reduceMotion}
                        initial={{ opacity: 0, y: reduceMotion ? 0 : 8 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, transition: { duration: 0.15 } }}
                        transition={EASE}
                        className="grid"
                    >
                        <CourseCard course={course} />
                    </motion.div>
                ))}
            </AnimatePresence>
        </div>
    );
}
